<template lang='pug'>
.scoreboard
  .scoreboard__wrapper
    ul(
      class="scorelist"
      ref="list"
      :style="{ top: setTopPostion }"
    )
      li.scorelist__item(
        v-for="(data, index) in scoreData"
        :key="index"
      )
        div(
          class="scorelist__score scorelist__score_name"
        ) {{ data.name }}
        div(
          class="scorelist__score scorelist__score_total"
          title="Всего"
        ) {{ data.total }}
        div(
          class="scorelist__score scorelist__score_hold"
          title="Заблокировано"
        ) {{ data.hold }}
        div(
          class="scorelist__score scorelist__score_withdraw"
          title="Списано"
        ) {{ data.withdraw }}
        div(
          class="scorelist__score scorelist__score_current"
          title="Доступно"
        ) {{ data.current }}
  .control(v-if="addControl")
    button(
      :class="['control__button control__button_up', {disable: disableUpButton}]"
      @click="setScore(0)"
    )
    button(
      class="control__button control__button_down"
      :class="['control__button control__button_up', {disable: disableDownButton}]"
      @click="setScore(1)"
    )
</template>

<script>
export default {
  name: 'ComponentPartsScoreboard',

  props: {
    scoreData: {
      type: Array,
      default: () => []
    },
  },

  data: () => ({
    topPostion: 0,
    disableUpButton: true,
    disableDownButton: false,
  }),

  computed: {
    addControl() {
      return this.scoreData.length > 2;
    },

    setTopPostion() {
      const { topPostion } = this;
      return `${topPostion}px`;
    },
  },

  methods: {
    setScore(direction) {
      const { clientHeight } = this.$refs.list;
      const step = 20;

      if(direction == 1 && Math.abs(this.topPostion) < (clientHeight - step)) {
        this.topPostion = this.topPostion - step;
        this.disableUpButton = false;
      }

      if(direction == 0 && this.topPostion < 0) {
        this.topPostion = this.topPostion + step;
        this.disableDownButton = false;
      }

      if(this.topPostion == 0 ) this.disableUpButton = true;
      if(Math.abs(this.topPostion) == (clientHeight - step)) this.disableDownButton = true;
    },
  },
};
</script>

<style lang='stylus' scoped>
@import '../../../stylus/helpers/mediaqueriesStep'

.scoreboard
  display none

  +tablet-desktop()
    display flex

  &__wrapper
    width 480px
    height 16px
    margin-top -1px
    overflow hidden
    position relative

.scorelist
  width 100%
  display flex
  flex-wrap wrap
  justify-content flex-end
  list-style none
  position absolute
  top 0

  &__item
    height 16px
    margin 0 9px 4px 0
    padding-right 9px
    position relative

    &:last-child,
    &:nth-child(2n)
      margin-right 0
      padding-right 0

      &::after
        display none

    &::after
      content ''
      width 1px
      height 14px
      display block
      background-color #8482d3
      position absolute
      top 3px
      right -1px

  &__score
    margin-right 7px
    padding-left 14px
    font-size 10px
    font-weight 700
    color #1f1555
    display inline-block
    position relative

    &::before
      content ''
      width 10px
      height 10px
      position absolute
      top 0
      left 0

    &:last-child
      margin-right 0

    &_name
      padding-left 0
      font-size 13px
      font-weight 600
      color #ee9437

    &_total
      &::before
        background url('./images/sprint.png') 0 50% no-repeat

    &_hold
      &::before
        background url('./images/sprint.png') -11px 50% no-repeat

    &_withdraw
      &::before
        background url('./images/sprint.png') -22px 50% no-repeat

    &_current
      &::before
        background url('./images/sprint.png') -33px 50% no-repeat

.control
  width 8px
  height 17px
  margin-left 12px
  display flex
  flex-direction column
  justify-content space-between

  &__button
    width 8px
    height 7px
    border none
    background-color transparent
    cursor pointer

    &:focus
      outline none

    &_up
      background url('./images/sprint.png') -44px 10% no-repeat

      &:hover
        background url('./images/sprint.png') -53px 10% no-repeat

    &_down
      background url('./images/sprint.png') -44px 90% no-repeat

      &:hover
        background url('./images/sprint.png') -53px 90% no-repeat

.disable
  opacity .5
  cursor default
</style>



// WEBPACK FOOTER //
// Scoreboard.vue?b8127ef4